import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Form } from 'antd';
import { toString, forEach } from 'lodash';
import validator from 'validator';
import { connect } from 'react-redux';

import helpers from 'utils/helpers';
import { requestResetPasswordRequest } from 'ducks/auth';
import {
  FormTitle,
  StyledFormItem,
  StyledInput,
  StyledButton
} from 'components/Styled';

class ForgotPassword extends Component {
  state = {
    showInput: true,
    email: ''
  };

  gtmEvents = {
    // reserve use
    // email: `Inputted Login Email`
  };

  handleTextInputChange = (value, name) => {
    this.setState({
      [name]: value
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        loginInput: toString(this.state[name])
      });
    }

    this.setState({
      [name + 'Status']: this.validateError(name) ? 'error' : '',
      [name + 'Help']: this.validateError(name)
    });
  };

  validateType = {
    email: 'email'
  };

  validate = () => {
    const fields = ['email'];

    const states = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      states[field + 'Status'] = this.validateError(field) ? 'error' : '';
      states[field + 'Help'] = this.validateError(field);
    });

    this.setState(states);

    for (var i = 0; i < fields.length; i++) {
      if (this.validateError(fields[i])) {
        return false;
      }
    }
    return true;
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    switch (this.validateType[name]) {
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `auth.err_msg.${name}.format`;
        }
        return null;
      case 'email':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `auth.err_msg.${name}.empty`;
        }
        if (!validator.isEmail(value)) {
          return `auth.err_msg.${name}.format`;
        }

        return null;
      default:
        return null;
    }
  };

  handleAction = () => {
    if (!this.validate()) {
      return helpers.scrollToError();
    }

    this.props.requestResetPasswordRequest({
      email: this.state.email
    });
  };

  toRegister = () => {
    window.location.href = 'https://ship.spaceshipapp.com/signup';
  };

  toLogin = () => {
    this.props.onPageChange('login');
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      !prevProps.requestResetPasswordSuccess &&
      this.props.requestResetPasswordSuccess
    ) {
      this.setState({
        showInput: false
      });
    }
  }

  componentDidMount() {
    window.dataLayer.push({
      event: 'Land Forgot Password'
    });
  }

  render() {
    return (
      <div
        style={{
          backgroundColor: '#fafafa',
          minHeight: '100%'
        }}>
        {this.state.showInput ? (
          <React.Fragment>
            <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: 700 }}>
                {this.props.t('auth.forget_password.forget')}
              </div>
              <div style={{ fontSize: '12px', paddingTop: '5px' }}>
                {this.props.t('auth.forget_password.forget_text1')}
                <br />
                {this.props.t('auth.forget_password.forget_text2')}
              </div>
            </div>
            <Form>
              <div style={{ padding: '' }}>
                <FormTitle>Email</FormTitle>
                <StyledFormItem
                  validateStatus={this.state['emailStatus'] || ''}
                  help={this.props.t(this.state['emailHelp'])}>
                  <StyledInput
                    size="large"
                    value={this.state['email']}
                    onChange={e => {
                      this.handleTextInputChange(e.target.value, 'email');
                    }}
                    onBlur={e => {
                      this.handleTextInputBlur('email');
                    }}
                  />
                </StyledFormItem>
              </div>
              <div style={{ padding: '15px 0' }}>
                <StyledButton
                  onClick={this.handleAction}
                  type="primary"
                  loading={this.props.loading}
                  htmlType="submit"
                  shadow="true"
                  block>
                  {this.props.t('auth.forget_password.reset')}
                </StyledButton>
              </div>
              <div style={{ paddingTop: '65px', textAlign: 'center' }}>
                <span
                  style={{
                    color: '#9900A5',
                    textDecoration: 'underline',
                    cursor: 'pointer'
                  }}
                  onClick={this.toRegister}>
                  {this.props.t('auth.forget_password.register_new')}
                </span>
              </div>
            </Form>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div style={{ padding: '50px 0 45px', textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: 700 }}>
                {this.props.t('auth.forget_password.forget')}
              </div>
              <div style={{ fontSize: '12px', paddingTop: '5px' }}>
                {this.props.t('auth.forget_password.check_email')}
              </div>
            </div>
            <div style={{ paddingTop: '65px', textAlign: 'center' }}>
              <span
                style={{
                  color: '#9900A5',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={this.toLogin}>
                {this.props.t('auth.forget_password.back')}
              </span>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.auth.loading,
    requestResetPasswordSuccess: !!state.auth.requestResetPasswordSuccess
  };
};

const mapDispatchToProps = {
  requestResetPasswordRequest
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)
);
